export default function formatRating(value) {
  const num = Number(value);
  if (!isFinite(num)) return "";
  return num % 1 === 0 ? String(num) : num.toFixed(1);
}
